const DEFAULT_SOCIALS_ACCOUNT_ID = "3f7c2a6e-7a5c-4c7a-9b5d-3c2f8d1a6e7b";
const DEFAULT_JOB_TRIGGER_COOLDOWN_SECONDS = 60;
const config = {
    ACCOUNT_ID: process.env.REACT_APP_SOCIALS_ACCOUNT_ID || DEFAULT_SOCIALS_ACCOUNT_ID,
    JOB_TRIGGER_COOLDOWN_SECONDS: (() => {
        const raw = process.env.REACT_APP_SOCIALS_JOB_TRIGGER_COOLDOWN_SECONDS;
        if (!raw)
            return DEFAULT_JOB_TRIGGER_COOLDOWN_SECONDS;
        const parsed = Number(raw);
        if (!Number.isFinite(parsed) || parsed <= 0) {
            return DEFAULT_JOB_TRIGGER_COOLDOWN_SECONDS;
        }
        return parsed;
    })()
};
export default config;
